import { render, staticRenderFns } from "./pieDetails.vue?vue&type=template&id=42f5ca4e&scoped=true&"
import script from "./pieDetails.vue?vue&type=script&lang=js&"
export * from "./pieDetails.vue?vue&type=script&lang=js&"
import style0 from "./pieDetails.vue?vue&type=style&index=0&id=42f5ca4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5ca4e",
  null
  
)

export default component.exports